let activeRefresher = null;
/** Called by `<AuthProvider>`. Returns the unregister function. */
export function registerSessionRefresher(refresher) {
    activeRefresher = refresher;
    return () => {
        if (activeRefresher === refresher)
            activeRefresher = null;
    };
}
/**
 * Call after an authed request sent with `failedToken` got a 401. Resolves true when a newer
 * session token is now stored (retry the request once with it), false when the session could
 * not be refreshed (treat the user as signed out). Concurrent calls share one refresh.
 */
export function refreshSessionOnce(failedToken) {
    return activeRefresher === null ? Promise.resolve(false) : activeRefresher(failedToken);
}
//# sourceMappingURL=session-refresh.js.map